module.exports = __webpack_public_path__ + "static/media/button_soraed02796b740e36ee5febf09c319fdbba.webp";